import type { IconTypes } from "solid-icons"
import { BiRegularGridAlt } from 'solid-icons/bi'
import { FaSolidSquare } from "solid-icons/fa"
import { SelectionMode } from "./SelectionMode.enum"

interface SelectionModeMeta {
  value: SelectionMode
  label: string
  icon: IconTypes
}

const selectionModeMetaList : Array<SelectionModeMeta> = [
  {
    value: SelectionMode.SingleSelect,
    label: 'Single Select',
    icon: FaSolidSquare,
  },
  {
    value: SelectionMode.MultiSelect,
    label: 'Multi Select',
    icon: BiRegularGridAlt,
  },
]

export default selectionModeMetaList